var winWidth = $(window).width();

function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

if (isTouchDevice()) {
  $("html").addClass("is-touch");
}

$(window).resize(function () {
  spanRight();
  spanLeft();
});

if (navigator.platform.indexOf("Mac") > -1) {
  $("body").addClass("is-mac");
} else if (navigator.platform.indexOf("Win") > -1) {
  $("body").addClass("is-pc");
}

function spanRight() {
  $(".span-right.wp-block-column").each(function (i) {
    if (winWidth > 991) {
      var group = $(this).parent().closest(".wp-block-group");
      var width = group.outerWidth();
      var height = group.outerHeight();
      var child = $(this)
        .children()
        .addClass("is-spanning")
        .css({ width: width / 2 });
    }
  });
}

function spanLeft() {
  $(".span-left.wp-block-column").each(function (i) {
    if (winWidth > 991) {
      var colOffset = $(this).offset();
      var group = $(this).parent().closest(".wp-block-group");
      var width = group.outerWidth();
      var height = group.outerHeight();
      var child = $(this)
        .children()
        .addClass("is-spanning")
        .css({ width: width / 2, "margin-left": -1 * colOffset.left });
    }
  });
}

spanRight();
spanLeft();

$(".back-to-top").on("click", function (e) {
  e.preventDefault();
  $("html, body").animate(
    {
      scrollTop: 0,
    },
    750
  );
});

// Add class to body on hamburger click
$(".navbar-toggler").on("click", function (e) {
  e.preventDefault();

  $("body").toggleClass("menu-is-open");
  $("body").removeClass("is-searching");

  if (!$("body").hasClass("menu-is-open")) {
    $(".nav-search").removeClass("is-showing");
    $(".menu-item").not(".nav-search").removeClass("is-hiding");
  } else {
    $(".dropdown").removeClass("is-expanded");
    $("#menu-primary-menu")
      .removeClass("depth-0-expanded")
      .removeClass("depth-1-expanded");
  }

  if ($("body").hasClass("menu-is-open")) {
    $(this).attr("aria-expanded", "true");
    $(this).attr("aria-label", "Close navigation");
    $(".navbar--container").attr("aria-hidden", "false");
  } else {
    $(this).attr("aria-expanded", "false");
    $(this).attr("aria-label", "Menu navigation");
    $(".navbar--container").attr("aria-hidden", "true");
  }
});

$(".navbar--back").on("click", function (e) {
  e.preventDefault();
  $(".dropdown").removeClass("is-expanded");
  $("#menu-primary-menu")
    .removeClass("depth-0-expanded")
    .removeClass("depth-1-expanded");
});

$(".navbar-search").on("click", function (e) {
  e.preventDefault();

  $("body").removeClass("menu-is-open").toggleClass("is-searching");

  if ($("body").hasClass("is-searching")) {
    $(this).attr("aria-expanded", "true");
    $(".wp-block-search").attr("aria-hidden", "false");

    setTimeout(function () {
      $('.wp-block-search input[type="search"]').focus();
    }, 300);
  } else {
    $(this).attr("aria-expanded", "false");
    $(".wp-block-search").attr("aria-hidden", "true");
  }
});

$(".depth-0.dropdown > a").on("click", function (e) {
  e.preventDefault();

  $(".depth-0.dropdown")
    .attr("aria-expanded", "false")
    .removeClass("is-expanded");
  $(this).parent().attr("aria-expanded", "true").addClass("is-expanded");

  if (winWidth < 992) {
    $("#menu-primary-menu").addClass("depth-0-expanded");
  }
});

$(".depth-1.dropdown > a").on("click", function (e) {
  e.preventDefault();

  $(".depth-1.dropdown")
    .attr("aria-expanded", "false")
    .removeClass("is-expanded");
  $(this).parent().attr("aria-expanded", "true").addClass("is-expanded");

  if (winWidth < 992) {
    $("#menu-primary-menu").addClass("depth-1-expanded");
  }
});

$(".ginput_container input:not(:file), .ginput_container textarea").on(
  "focusout",
  function (e) {
    var thisVal = $(this).val();

    if (thisVal) {
      $(this).parent().addClass("has-value");
    } else {
      $(this).parent().removeClass("has-value");
    }
  }
);

if ($(".blank").length > 0) {
  $(".blank").each(function (index, value) {
    $(this)
      .find("a")
      .attr("target", "_blank")
      .attr("rel", "external noreferrer noopener");
  });
}
// Add event listener for ESC key
$(document).on("keydown", function (e) {
  if (e.key === "Escape") {
    if ($("body").hasClass("menu-is-open")) {
      $("body").removeClass("menu-is-open");
      $(".navbar--container").attr("aria-hidden", "true");
      $(".navbar-toggler")
        .attr("aria-expanded", "false")
        .attr("aria-label", "Menu navigation");
    }
    if ($("body").hasClass("is-searching")) {
      $("body").removeClass("is-searching");
      $(".wp-block-search").attr("aria-hidden", "true");
      $(".navbar-search").attr("aria-expanded", "false");
    }
  }
});
